import { render } from "./userDetail.vue?vue&type=template&id=11afc795&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"

import "./userDetail.vue?vue&type=style&index=0&id=11afc795&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11afc795"]])

export default __exports__